import {Component} from '@angular/core';

@Component({
  selector: 'nli-access-denied-page',
  templateUrl: './access-denied-page.component.html',
})
export class AccessDeniedPageComponent  {}
